import React from 'react'
import {
    BackButton,
    Bloc,
    Conditionnal,
    Header,
    ProgressBar,
    Title,
} from '../ImportAll'

export default function Vue2() {
    return (
        <div>
            <Header
                title="J'estime mon prêt"
                subTitle="Quel est votre projet immobilier ?"
            />
            <div className="Container">
                <div className="BackNavigationContainerLeft">
                    <BackButton />
                </div>
            </div>
            <div className="Container">
                <ProgressBar size={8} time={4} />
            </div>
            <div className="Container">
                <Conditionnal
                    linked_data_id="tech_source_neuf"
                    isEqualTo
                    targetDataValueCompare={true}
                >
                    <Bloc
                        key="key6"
                        selectable
                        linked_data_id="prj_type"
                        linked_data_value="LOGEMENT_NEUF"
                        height={178}
                        nbcolumn={2}
                        gauche
                        imageTextStyle
                        logourl="png/cred_loc.png"
                        text1="Achat d’un"
                        text2="logement neuf"
                        gtm_id="e2-Achat d'un logement neuf"
                    />
                    <Bloc
                        key="key7"
                        selectable
                        linked_data_id="prj_type"
                        linked_data_value="TERRAIN_ET_CONSTRUCTION"
                        height={178}
                        targetView={3}
                        nbcolumn={2}
                        droit
                        imageTextStyle
                        logourl="svg/rp.svg"
                        text1="Achat d’un"
                        text2="terrain et / ou construction"
                        gtm_id="e2-Achat d'un terrain et/ou construction"
                    />
                </Conditionnal>
                <Conditionnal
                    linked_data_id="tech_source_neuf"
                    isNotEqualTo
                    targetDataValueCompare={true}
                >
                    <Bloc
                        key="key5"
                        selectable
                        linked_data_id="prj_type"
                        linked_data_value="LOGEMENT_ANCIEN"
                        height={178}
                        targetView={3}
                        nbcolumn={2}
                        gauche
                        imageTextStyle
                        logourl="svg/ancien.svg"
                        text1="Achat d’un"
                        text2="logement ancien"
                        gtm_id="e2-Achat d'un logement ancien"
                    />
                    <Bloc
                        key="key6"
                        selectable
                        linked_data_id="prj_type"
                        linked_data_value="LOGEMENT_NEUF"
                        height={178}
                        nbcolumn={2}
                        droit
                        imageTextStyle
                        logourl="png/cred_loc.png"
                        text1="Achat d’un"
                        text2="logement neuf"
                        gtm_id="e2-Achat d'un logement neuf"
                    />

                    <Bloc
                        key="key7"
                        selectable
                        linked_data_id="prj_type"
                        linked_data_value="TERRAIN_ET_CONSTRUCTION"
                        height={178}
                        targetView={3}
                        nbcolumn={2}
                        gauche
                        imageTextStyle
                        logourl="svg/rp.svg"
                        text1="Achat d’un"
                        text2="terrain et / ou construction"
                        gtm_id="e2-Achat d'un terrain et/ou construction"
                    />
                    <Bloc
                        key="key8"
                        selectable
                        linked_data_id="prj_type"
                        linked_data_value="RENEGOCIATION"
                        linked_data_id_2="prj_maturite"
                        linked_data_value_2="TROUVE"
                        height={178}
                        targetView={3}
                        nbcolumn={2}
                        droit
                        imageTextStyle
                        logourl="svg/renego.svg"
                        text1="Prêt immobilier"
                        text2="renégociation"
                        gtm_id="e2-Prêt immobilier renégociation"
                    />
                    <Bloc
                        key="key9"
                        selectable
                        linked_data_id="prj_type"
                        linked_data_value="TRAVAUX"
                        height={178}
                        targetView={3}
                        nbcolumn={2}
                        gauche
                        imageTextStyle
                        logourl="png/cred_travaux.png"
                        text1="Logement ancien"
                        text2="travaux"
                        gtm_id="e2-Logement ancien travaux"
                    />
                    <Bloc
                        key="key10"
                        selectable
                        linked_data_id="prj_type"
                        linked_data_value="ACHAT_SCPI"
                        height={178}
                        targetView={3}
                        nbcolumn={2}
                        droit
                        imageTextStyle
                        logourl="svg/scpi.svg"
                        text1="Achat de"
                        text2="parts SCPI"
                        gtm_id="e2-Achat de parts SCPI"
                    />
                </Conditionnal>
            </div>

            <Conditionnal
                linked_data_id="prj_type"
                isEqualTo
                targetDataValueCompare="LOGEMENT_NEUF"
            >
                <div className="Container">
                    <Title maintitle="De quel type de bien est-il question ?" />
                    <Bloc
                        key="key11"
                        selectable
                        linked_data_id="prj_type_log"
                        linked_data_value="APPARTEMENT"
                        height={120}
                        targetView={3}
                        nbcolumn={2}
                        gauche
                        imageTextStyle
                        logourl="png/cred_loc.png"
                        text1=""
                        text2="Appartement"
                        gtm_id="e2-Appartement"
                    />
                    <Bloc
                        key="key12"
                        selectable
                        linked_data_id="prj_type_log"
                        linked_data_value="IMMEUBLE"
                        height={120}
                        targetView={3}
                        nbcolumn={2}
                        droit
                        imageTextStyle
                        logourl="png/cred_loc.png"
                        text1=""
                        text2="Immeuble"
                        gtm_id="e2-Immeuble"
                    />
                    <Bloc
                        key="key13"
                        selectable
                        linked_data_id="prj_type_log"
                        linked_data_value="MAISON_COLLECTIVE"
                        height={120}
                        targetView={3}
                        nbcolumn={2}
                        gauche
                        imageTextStyle
                        logourl="svg/rp.svg"
                        text1=""
                        text2="Maison collective"
                        gtm_id="e2-Maison collective"
                    />
                    <Bloc
                        key="key155"
                        selectable
                        linked_data_id="prj_type_log"
                        linked_data_value="PSLA"
                        height={120}
                        targetView={3}
                        nbcolumn={2}
                        droit
                        imageTextStyle
                        logourl="svg/rp.svg"
                        text1=""
                        text2="PSLA ou BRS"
                        gtm_id="e2-type PSLA ou BRS"
                    />
                    <Bloc
                        key="key14"
                        selectable
                        linked_data_id="prj_type_log"
                        linked_data_value="MAISON_INDIVIDUELLE"
                        height={120}
                        targetView={3}
                        nbcolumn={2}
                        gauche
                        imageTextStyle
                        logourl="svg/rp.svg"
                        text1=""
                        text2="Maison individuelle"
                        gtm_id="e2-Maison individuelle"
                    />
                    <Bloc
                        key="key15"
                        selectable
                        linked_data_id="prj_type_log"
                        linked_data_value="AUTRE"
                        height={120}
                        targetView={3}
                        nbcolumn={2}
                        droit
                        imageTextStyle
                        logourl="svg/rp.svg"
                        text1=""
                        text2="Autre"
                        gtm_id="e2-Autre type de bien"
                    />
                </div>
            </Conditionnal>
        </div>
    )
}
